import styled from 'styled-components';

export const wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 20px 0 40px;
`;

export const icon = styled.div`
  width: 15px;
  margin-right: 9px;
`;
